import { Provider as ReduxProvider } from 'react-redux'
import { ThemeProvider } from 'styled-components'
import { LinkProvider } from '@zera-admin/link'

import { store } from 'app/redux'
import { PopupProvider } from 'app/contexts/popup'
import CustomLink from 'components/custom-link'
import { FlagcardProvider } from 'app/contexts/flagcard'
import { LanguageProvider } from 'app/contexts/language'
import { LetterOfConsentProvider } from 'app/contexts/letterOfConsent'

const Provider: React.FunctionComponent = ({ children }) => {
  const theme = {}

  return (
    <ThemeProvider theme={theme}>
      <LinkProvider component={CustomLink}>
        <ReduxProvider store={store}>
          <LanguageProvider>
            <FlagcardProvider>
              <LetterOfConsentProvider>
                <PopupProvider>{children}</PopupProvider>
              </LetterOfConsentProvider>
            </FlagcardProvider>
          </LanguageProvider>
        </ReduxProvider>
      </LinkProvider>
    </ThemeProvider>
  )
}

export default Provider
